import { combineReducers } from 'redux'
import sessionReducer from './sessionReducer'
import vestigiosReducer from './vestigiosReducer'
import mapaReducer from './mapaReducer'
import usuariosReducer from './usuariosReducer'
import casosReducer from './casosReducer'
import cargosReducer from './cargoReducer'
import orgaosReducer from './orgaoReducer'
import regionaisReducer from './orgao.regionalReducer'
import divisoesReducer from './orgao.divisaoReducer'
import setoresReducer from './orgao.setorReducer'
import alertasReducer from './alertasReducer'
import examesReducer from './exameReducer'
import idsStateReducer from './idsStateReducer'
import gerenciamentoBalisticaReducer from './gerenciamentoBalisticaReducer'
import examesSolicitadosReducer from './examesSolicitadosReducer'
import meusExamesReducer from './meusExamesReducer'
import solicitacaoExameReducer from './solicitacaoExameReducer'
import exameEficienciaReducer from './edicaoExame/exameEficienciaReducer'
import exameComparacaoReducer from './edicaoExame/exameComparacaoReducer'
import editorExameRealizadoReducer from './edicaoExame/editorExameRealizadoReducer'
import exameRealizadoReducer from './edicaoExame/exameRealizadoReducer'
import optionReducer from './optionReducer'
import exameGenericoReducer from './edicaoExame/exameGenericoReducer'
import pdfReducer from './pdfReducer'

const rootReducer = combineReducers({
  session: sessionReducer,
  vestigio: vestigiosReducer,
  mapa: mapaReducer,
  usuarios: usuariosReducer,
  setores: setoresReducer,
  casos: casosReducer,
  cargos: cargosReducer,
  orgaos: orgaosReducer,
  regionais: regionaisReducer,
  divisoes: divisoesReducer,
  alertas: alertasReducer,
  exames: examesReducer,
  idsState: idsStateReducer,
  gerenciamentoBalistico: gerenciamentoBalisticaReducer,
  exameSolicitado: examesSolicitadosReducer,
  meusExames: meusExamesReducer,
  solicitacaoExame: solicitacaoExameReducer,
  exameEficiencia: exameEficienciaReducer,
  exameComparacaoBalistica: exameComparacaoReducer,
  editorExameRealizado: editorExameRealizadoReducer,
  exameRealizado: exameRealizadoReducer,
  exameGenerico: exameGenericoReducer,
  options: optionReducer,
  pdf: pdfReducer,
})

export default rootReducer
